module.exports = __webpack_public_path__ + "img/tpl.1c7f1ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/advancedVersion/tpl.png
// module id = rXGj
// module chunks = 2 3 6 8 15 49